import React from 'react';

/*
What the ticket list shows, for the shared DataTable.

A ticket is unreadable as just a name and a slug — whether it has a price, when
its show is and whether it is on sale are what an editor opens the list to find
out. Sorting is server-side, so only the columns the backend whitelists are
marked sortable; the computed ones are not, because there is nothing to sort on.
*/
const priceLabel = (ticket) => {
  const price = Number(ticket.price);
  if (!Number.isFinite(price) || price <= 0) return '—';
  return `${price} ${ticket.currency || ''}`.trim();
};

const ticketColumns = (handleClick, ticketNote) => [
  { field: '_id', headerName: 'id', type: 'string', hide: true, isId: true },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'left',
    content: rowData => (
      <span
        className="font-icon icon-edit text-20 cursor-pointer"
        title="Edit ticket"
        onClick={() => handleClick('modify', rowData.ticketSlugName)}
      />
    ),
  },
  { field: 'ticketName', headerName: 'name', type: 'string', sortable: true, align: 'left' },
  { field: 'ticketSlugName', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  { field: 'date', headerName: 'show date', type: 'date', sortable: true, align: 'left' },
  {
    field: 'price',
    headerName: 'price',
    type: 'action',
    sortable: true,
    align: 'right',
    content: rowData => priceLabel(rowData),
  },
  { field: 'status', headerName: 'status', type: 'string', sortable: true, align: 'left' },
  {
    field: 'show',
    headerName: 'shown',
    type: 'boolean',
    align: 'center',
    description: 'Whether the ticket is displayed on the site',
  },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'left',
    // Only tickets that could reach a tours page carry this.
    content: (rowData) => {
      const note = ticketNote(rowData);
      return note ? <span className="text-orange-dark">{`⚠ ${note}`}</span> : null;
    },
  },
  { field: 'createdAt', headerName: 'created', type: 'date', sortable: true, align: 'left', description: 'When the record was created' },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'right',
    content: rowData => (
      <span
        className="font-icon icon-trash text-20 cursor-pointer"
        title="Delete ticket"
        onClick={() => handleClick('delete', rowData.ticketSlugName)}
      />
    ),
  },
];

export default ticketColumns;
